import { render } from "./Size.vue?vue&type=template&id=c791a618&scoped=true"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"

import "./Size.vue?vue&type=style&index=0&id=c791a618&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c791a618"]])

export default __exports__